import { START_LOADING, END_LOADING, GET_PRICES, SET_ERROR } from "../type";
import * as services from "../../services/product.services";
import { getPagesFromLabel } from "../../helper/utility";
import { serverResponse } from "../../util/fakeServer";

export const getPricesAction = (str) => async (dispatch) => {
  const pages = getPagesFromLabel(str.toString());

  let productsArray = serverResponse.pages[pages[0]].filter(
    (el) => el !== null
  );

  for (let index = 1; index < pages.length; index++) {
    productsArray = productsArray.concat(
      serverResponse.pages[pages[index]].filter((el) => el !== null)
    );
  }

  if (productsArray.length > 0) {
    try {
      dispatch({ type: START_LOADING });
      const {
        data: { data: res },
      } = await services.getPrices(
        productsArray,
        serverResponse.config.id_listino
      );

      dispatch({
        type: GET_PRICES,
        payload: res[0].data,
      });
    } catch (error) {
      dispatch({
        type: SET_ERROR,
        payload: error,
      });
      dispatch({
        type: END_LOADING,
      });
    }
  }
};
